import { render, staticRenderFns } from "./SimpleTextBox.vue?vue&type=template&id=ed139728&"
import script from "./SimpleTextBox.vue?vue&type=script&lang=js&"
export * from "./SimpleTextBox.vue?vue&type=script&lang=js&"
import style0 from "./SimpleTextBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports